import { restClient } from '@/Core'
import type { Message } from '../Contracts'
import { mapApiMessage, type ApiMessage } from '../Helpers/apiMappers'

interface MessagesResponse {
    items?: ApiMessage[]
    meta?: { hasMore?: boolean }
}

interface LoadChatMessagesParams {
    chatId: string
    /** Cursor: id of the oldest already loaded message — returns older ones */
    before?: string
    limit?: number
}

/**
 * A page of chat messages, newest first (cursor pagination).
 * First call: { chatId }. Older pages: { chatId, before: oldestLoadedId }.
 */
export const LoadChatMessagesTask = async ({
    chatId,
    before,
    limit = 30,
}: LoadChatMessagesParams): Promise<{ messages: Message[]; hasMore: boolean }> => {
    const response = (await restClient.get(
        `/services/chat/chats/${chatId}/messages`,
        { searchParams: { limit, ...(before ? { before } : {}) } },
        { forceRefresh: true }
    )) as MessagesResponse | null

    return {
        messages: (response?.items ?? []).map((item) => mapApiMessage(item, chatId)),
        hasMore: response?.meta?.hasMore ?? false,
    }
}
